import { type PageInfo } from '@blaze-shared/api-contracts-domain';
import { toPageSlug } from '@blaze-shared/shared-util';

import { type NavigationPageType } from './page.model';

export function createUniqueSlug(name: string | undefined, pages: PageInfo[]): string {
  name = name || '';
  let urlSlug = toPageSlug(name);
  if (!urlSlug) {
    urlSlug = crypto.randomUUID();
  }

  // If such slug already exists, append unique string to it.
  const existingSlugs = getExistingSlugs(pages);
  if (existingSlugs[urlSlug]) {
    let urlSlugWithUuid = `${urlSlug}-${crypto.randomUUID()}`;
    while (existingSlugs[urlSlugWithUuid]) {
      urlSlugWithUuid = toPageSlug(`${urlSlug}-${crypto.randomUUID()}`);
    }
    urlSlug = urlSlugWithUuid;
  }
  return urlSlug;
}

/**
 * A mapping of all page slugs (including default ones) to page name to which a given slug is assigned.
 * @returns
 */
export function getExistingSlugs(pages: PageInfo[]): Record<string, string> {
  const slugs: Record<string, string> = {};
  for (const page of pages || []) {
    slugs[page.urlSlug || toPageSlug(page.name)] = page.name;
  }
  return slugs;
}

const navigationPageTypes: NavigationPageType[] = ['Header', 'Bottombar', 'Sidebar'];

/**
 * Check if the page type is one of the navigation page types.
 * @param pageType
 */
export function isNavigationPageType(pageType?: string): pageType is NavigationPageType {
  return !!pageType && navigationPageTypes.includes(pageType as any);
}
